import { render } from "./TimerCurrent.vue?vue&type=template&id=371e6d20"
import script from "./TimerCurrent.vue?vue&type=script&lang=js"
export * from "./TimerCurrent.vue?vue&type=script&lang=js"
script.render = render

export default script